// Shared helpers for the character system UI.

export const RARITY = {
  common: { label: 'Comum', color: '#9AA0A6', glow: '#9AA0A6' },
  uncommon: { label: 'Incomum', color: '#39B54A', glow: '#39B54A' },
  rare: { label: 'Raro', color: '#3A8FD1', glow: '#3A8FD1' },
  legendary: { label: 'Lendário', color: '#D4AF37', glow: '#FFD700' },
};

export const rarityMeta = (rarity) => RARITY[rarity] || RARITY.common;

export const ACCENT_NEON = '#FF6030';

// #RRGGBB -> rgba(r,g,b,a)
export const hexToRgba = (hex, alpha = 1) => {
  if (!hex || typeof hex !== 'string') return `rgba(255,96,48,${alpha})`;
  const clean = hex.replace('#', '');
  const full = clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean;
  const num = parseInt(full, 16);
  if (Number.isNaN(num)) return `rgba(255,96,48,${alpha})`;
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return `rgba(${r},${g},${b},${alpha})`;
};

export const initials = (name = '') =>
  name
    .replace(/["'].*?["']/g, '') // drop nicknames in quotes
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || '')
    .join('');
